export default __webpack_public_path__ + "static/media/CaramelBar.b8c925ad.jpg";